module.exports = __webpack_public_path__ + "img/Frame_13.b5fba451.png";